import {
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	Title,
	Tooltip,
} from 'chart.js'
import { applyMask } from '../services/utils'

export const register = () => {
	ChartJS.register(
		CategoryScale,
		LinearScale,
		BarElement,
		Title,
		Tooltip,
		Legend
	)
}

export const dollarTicks = {
	callback(value: string | number) {
		return `$${applyMask(value, 'currency')}`
	},
}
